import React, { useState } from "react";
import { toDoData } from "./ToDoData";
import { ToDo } from "./ToDo";
import { CreateTask } from "./CreateTask";

function ToDoForm() {
  const [todo, setToDo] = useState(toDoData);

  const handleCreateTask = (newTask) => {
    const newToDos = [...todo, { title: newTask, complete: false }];
    setToDo(newToDos);
  };

  const handleEditTask = (index) => {
    const newToDos = [...todo];
    newToDos[index].completed = true;
    setToDo(newToDos);
  };

  const handleDeleteTask = (index) => {
    const newToDos = [...todo];
    newToDos.splice(index, 1);
    setToDo(newToDos);
  };

  return (
    <>
      <div className="container text-center pt-5">
        <div className="row p-5">
          <div className="col">
            <CreateTask handleCreateTask={handleCreateTask} />
          </div>
          <div className="col">
            <h3>Welcome to the Task Taker App</h3>
            <p>
              I have created a todo app as to show the use of all CRUD structure
              within a React application.
            </p>
          </div>
          <div className="row p-5">
            {todo.map((todo, index) => (
              <ToDo
                className="btn"
                key="1"
                index={index}
                todo={todo}
                handleEditTask={handleEditTask}
                handleDeleteTask={handleDeleteTask}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default ToDoForm;
